import React from "react";
import Slide from "@mui/material/Slide";
import useScrollTrigger from "@mui/material/useScrollTrigger";
import AppBar from "@mui/material/AppBar";

import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { Box, CssBaseline, Hidden } from "@mui/material";
import { Squash as Hamburger } from "hamburger-react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { Link } from "react-router-dom";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";

function HideOnScroll(props) {
  const { children, window } = props;
  // Note that you normally won't need to set the window ref as useScrollTrigger
  // will default to window.
  // This is only being set here because the demo is in an iframe.
  const trigger = useScrollTrigger({
    target: window ? window() : undefined,
  });

  return (
    <Slide appear={false} direction="down" in={!trigger}>
      {children}
    </Slide>
  );
}

const Header = (props) => {
  const [isOpen, setOpen] = React.useState(false);
  const [value, setValue] = React.useState(0);
  const [isDrawerOpen, setIsDrawerOpen] = React.useState(false);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      <CssBaseline />
      <HideOnScroll {...props}>
        <AppBar>
          <Toolbar>
            <Typography
              component={Link}
              to="/"
              sx={{
                fontWeight: 700,
                fontSize: {
                  xs: "1.8rem",
                  md: "2.5rem",
                  cursor: "pointer",
                  color: "white",
                },
              }}
            >
              Crypto_Sample
            </Typography>
            <Hidden mdUp>
              {" "}
             <Box sx={{ml:'auto'}}>
             <Hamburger
                toggled={isOpen}
                toggle={setOpen}
                onToggle={() => setIsDrawerOpen((prev) => !prev)}
              />
             </Box>
              <SwipeableDrawer
                anchor="left"
                open={isDrawerOpen}
                onClose={() => {
                  setIsDrawerOpen(false);
                  setOpen(false);
                }}
                onOpen={() => {
                  setIsDrawerOpen(true);
                  setOpen(true);
                }}
              >
                <List>
                  <ListItem
                    onClick={() => setIsDrawerOpen(false)}
                    component={Link}
                    to="/cryptos"
                  >
                    Cryptos Table
                  </ListItem>
                  <ListItem
                    onClick={() => setIsDrawerOpen(false)}
                    component={Link}
                    to="/news"
                  >
                    News
                  </ListItem>
                </List>
              </SwipeableDrawer>
            </Hidden>
            <Hidden mdDown>
              <Tabs
                sx={{ ml: "auto" }}
                TabIndicatorProps={{ style: { display: "none" } }}
                value={value}
                onChange={handleChange}
                aria-label="basic tabs example"
              >
                <Tab
                  sx={{ color: "white !important" }}
                  component={Link}
                  to="/cryptos"
                  label="Cryptos Table"
                />
                <Tab
                  sx={{ color: "white !important" }}
                  component={Link}
                  to="/news"
                  label="News"
                />
              </Tabs>
            </Hidden>
          </Toolbar>
        </AppBar>
      </HideOnScroll>

      <Toolbar id='back-to-top-anchor' />
      <Toolbar />
    </>
  );
};

export default Header;
